import { render, staticRenderFns } from "./DetailSite.vue?vue&type=template&id=6eb9de72"
import script from "./DetailSite.vue?vue&type=script&lang=ts"
export * from "./DetailSite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports